import { useState } from "react"
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaSoundcloud, FaSpotify } from "react-icons/fa"

const Footer = () => {

  return (
    <footer className="bg-[#1a1f25] text-white">
      <div className="max-w-[1200px] mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 py-16">
          <div>
            <h3 className="text-lg font-semibold mb-6 font-primary">Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="/artificial" className="text-sm text-gray-400 hover:text-white font-primary">
                  Artificial Inteligence
                </a>
              </li>
              <li>
                <a href="/business-devlopment" className="text-sm text-gray-400 font-primary hover:text-white">
                  Business-devlopment
                </a>
              </li>
              <li>
                <a href="web-development" className="text-sm text-gray-400 font-primary hover:text-white ">
                  Web Development
                </a>
              </li>
              <li>
                <a href="mobile-app" className="text-sm font-primary text-gray-400 hover:text-white">
                  Mobile App
                </a>
              </li>
              <li>
                <a href="graphic-designing" className="text-sm font-primary text-gray-400 hover:text-white">
                  Graphic Designing
                </a>
              </li>
              <li>
                <a href="dev-ops" className="text-sm text-gray-400 font-primary hover:text-white">
                  DevOps
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 font-primary">Engineering</h3>
            <ul className="space-y-3">

              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Product Development
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Application Development
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Application Modernization
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  POC Development
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  AI Software Development
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Cloud Engineering
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Cloud Migration
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 font-primary">Artificial Intelligence</h3>
            <ul className="space-y-3">
              <li>
                <a href="/artificial" className="text-sm text-gray-400 font-primary hover:text-white">
                  AI Workshop
                </a>
              </li>
              <li>
                <a href="/artificial" className="text-sm text-gray-400 font-primary hover:text-white">
                  AI PoC & MVP
                </a>
              </li>
              <li>
                <a href="/artificial" className="text-sm text-gray-400 font-primary hover:text-white">
                  Generative AI
                </a>
              </li>
              <li>
                <a href="/artificial" className="text-sm text-gray-400 font-primary hover:text-white">
                  Machine Learning
                </a>
              </li>
              <li>
                <a href="/artificial" className="text-sm text-gray-400 font-primary hover:text-white">
                  MLOps
                </a>
              </li>
              <li>
                <a href="/artificial" className="text-sm text-gray-400 font-primary hover:text-white">
                  Conversational AI
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 font-primary">Optimization</h3>
            <ul className="space-y-3">
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Software Audit
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Quality Assurance
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-sm text-gray-400 font-primary hover:text-white">
                  Support & Maintenance
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-6 font-primary">Portfolio</h3>
            <ul className="space-y-3">
              <li>
                <a href="/portfolio" className="text-sm text-gray-400 font-primary hover:text-white">
                  Projects
                </a>
              </li>
              <li>
                <a href="/customers" className="text-sm text-gray-400 font-primary hover:text-white">
                  Customers
                </a>
              </li>
            </ul>
          </div>


        </div>

        <div className="border-t border-gray-800">
          <div className="py-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="border-r border-gray-800 pr-8 pt-3">
                <a href="/" className="text-3xl text-bold font-primary">
                  BizzDevs
                </a>
              </div>

              <div className="border-r border-gray-800 pr-8">
                <h4 className="text-sm font-semibold mb-2 font-primary">Address</h4>
                <p className="text-sm text-gray-400 font-primary">
                  611 South DuPont Highway Suite 102 (street) Dover, Delaware, 19901
                </p>
              </div>

              <div className="border-r border-gray-800 pr-8 font-primary">
                <h4 className="text-sm font-semibold mb-2 font-primary">Contact Us</h4>
                <a href="mailto:services@tkxel.com" className="text-sm text-gray-400 block hover:text-white">
                  services@bizzDevs.com
                </a>
                {/* <a href="tel:(202)978-3410" className="text-sm font-primary text-gray-400 block hover:text-white">
                  (202) 978-3410
                </a> */}
              </div>

              <div>
                <h4 className="text-sm font-semibold font-primary mb-2">Follow Us</h4>
                <div className="flex space-x-4">
                  <a
                    href="https://linkedin.com/in/bizzdevs"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn size={20} />
                  </a>
                  <a
                    href="https://www.facebook.com/share/1AjAZrd2Cu/"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF size={20} />
                  </a>
                  <a
                    href="https://instagram.com/bizzdevs"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram size={20} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

